export default [
    { name: 'Normal', value: 'normal' },
    { name: 'PWP', value: 'pwp' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/store/promotion-category.js